/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { Grid, GridItem } from '@patternfly/react-core';
//import InfoIcon from '@material-ui/icons/Info';
import useTranslateText from '../use_translate_text';
// import DatePicker from '../datepicker/datepicker';

import { makeStyles } from '@material-ui/core';
import { commonNodeModules } from '../index';
import DateFnsUtils from '@date-io/date-fns';
import { InputAdornment } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import InputRadio from './input_radio';
import { kebabCase } from 'lodash';
//import PhoneNumber from '../../common/phone_number/phone_number';
import TextFieldComponent from './TextFieldComponent';
// import { Box, TextField, MenuItem } from '@material-ui/core';
import { formLabelsTheme } from '../../style_jsx/styles';
import moment from 'moment';


const useStyles = makeStyles((theme) => ({
        root: {
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          [theme.breakpoints.down('sm')]: {
            overflow: 'auto',
          },
        },
        input: {
          height: 40,
          padding: 0,
          [theme.breakpoints.up('300')]: {
            width: 130,
          },
          [theme.breakpoints.up('576')]: {
            width: 140,
          },
          [theme.breakpoints.up('768')]: {
            width: 160,
          },
          [theme.breakpoints.up('1024')]: {
            width: 160,
          },
          color: '#76787A',
          fontSize: '14px',
        },
        datepicker: {
          'label + &': {
            marginBottom: 60,
            backgroundColor: 'red',
          },

        },
        checked: {},
      })),

      DatePickerComponent = (props) => {

        const classes = useStyles();
        const { Box } = commonNodeModules;
        let format = 'MM/dd/yyyy';
        let formatDate = props.field ? 'yyyy' : format;
        let views = props.field ? ['year'] : ['year', 'month', 'date'];
        return (
          <Grid item xs={12} className={classes.textFieldGrid}>

            <KeyboardDatePicker
              // maxDate={new Date()}
              views={views}
              // placeholder="-"
              inputVariant="outlined"
              format={formatDate}
              margin="dense"
              label=""
              value={props.defaultValue}
              onChange={props.handleDateChange}
              className={classes.datepicker}
              InputProps={{
                disableUnderline: true,
                color: '#76787A',
                className: `${classes.input}`,
                // style: {height: '24px'},
                endAdornment: (
                  <InputAdornment position="end">
                    <Box
                      onClick={() => {}}
                      className="calendarIcon"
                    />
                  </InputAdornment>
                ),
              }}
              // InputAdornmentProps = {{ position: 'right' }}
              fullWidth
              error={props.error}
              helperText={props.helperText}
            />
          </Grid>//
        );
      };

const InputFormEvents = (props) => {
  const { MuiThemeProvider, Box, TextField, MenuItem } = commonNodeModules;
  const { className, fields, titleText, titleSubText, onChange, subTexts } = props,
        { translateText } = useTranslateText(),
        //[phoneError, setPhoneError] = useState(false),
        classNames = `input-form ${className}`;
  const [selectedDate, setDate] = useState(moment());
  const [errorDate, setErrorDate] = useState(false);


  useEffect(() => (
    fields && fields.map((item => {
      console.log(item);
      if (item.key === 'Effective_Date') {
        if ('value' in item) {
          setDate(item.value);
          onChange('Effective_Date', item.value ? moment(item.value).format('MM/DD/YYYY') : item.value);
        }
        else {
          setDate(moment(new Date()).format('MM/DD/YYYY'));
          onChange('Effective_Date', moment(new Date()).format('MM/DD/YYYY'));
        }

      }
    }))
  ), []);

  const onDateChange = (date, value) => {
    setDate(date);
    // onChange('Effective_Date', date);
    if (date === null || JSON.stringify(date) === 'null') {
      onChange('Effective_Date', date === null ? null : date);
      setErrorDate(true);
    }
    let newVal = '';
    if ((value != null)) {
      if (String(value.includes('_'))) {
        newVal = value.replaceAll('_', '');
      }
      else {
        newVal = value;
      }
      if (newVal.length === 10 && JSON.stringify(date) !== 'null') {
        onChange('Effective_Date', date);
      }

    }
    else {
      setErrorDate(true);
    }
  };

  const onChangeField = (key, value, oldValue) => {
    if (key === 'Zip') {
      value = value.replace(/[^0-9\\.]+/g, '');
      let withoutcomma = value.replace(/[^0-9\\.]+/g, '');
      if (withoutcomma.length > 5) {
        if (withoutcomma.length > 9) {
          value = withoutcomma.slice(0, 5) + '-' + withoutcomma.slice(5, 9) + '-' + withoutcomma.slice(9, 12);
        }
        else {
          value = withoutcomma.slice(0, 5) + '-' + withoutcomma.slice(5, 9);
        }
      }
    }
    else if (key === 'SubDivision') {
      const len = (value?.length - 1) || 0,
            oldValueLen = (oldValue?.length - 1) || 0,
            valArray = value.split(''),
            numRegx = /^[0-9]$/,
            isDeleteKeyUp = oldValueLen > len,
            lastDigit = valArray[len];
      if (len > 0 && !isDeleteKeyUp) {
        if (!numRegx.test(lastDigit)) return;
        if (key === 'SubDivision' && len > 5) return;
      }
      value = valArray.join('');
    }
    onChange(key, value);
  };
  return (
    <MuiThemeProvider theme={formLabelsTheme}>
      <Grid className={classNames}>
        <GridItem lg={12}>
          {titleText &&
          <p className="f20-title pb-3">{translateText(titleText)}
            {titleSubText && <span className="I9-f14-title ml-1">{translateText(titleSubText)}</span>}
            {subTexts}
          </p>
          }
        </GridItem>
        {fields && fields.map((item, i) => {
          const { name, type, value, items, isDisable, key, errorMessage, isHidden, error, index, maxLength, isPSDText } = item,
                isText = type === '',
                isInputText = type === 'text',
                isDropdown = type === 'dropdown',
                isDatepicker = type === 'date',
                isRadio = type === 'radio',
                isPhone = type === 'phone',
                eventform = (name === 'Change of Address date') ? 12 : 3,

                itemProps = {
                  selectedItem: value,
                  disabled: isDisable,
                  data: items,
                  stateName: key,
                  value: value,
                  name: key,
                  lable: name,
                  autoComplete: 'off',
                  errorMessage,
                  index,
                  error,
                };
          return (
            <>
              {!isHidden &&
          <>

            <GridItem lg={eventform} key={i} className="pb-3 pr-3">
              <p className="f14-title"><span>{translateText(name)}</span></p>
              {isText && <p className="f14-content">{value}</p>}

              {isInputText &&
                <TextFieldComponent
                  value={value}
                  disabled={isDisable}
                  name={key}
                  maxLength={maxLength}
                  required
                  lable=""
                  onChange={(e) => onChangeField(key, e.target.value, value)}
                  error={error}
                  helperText={error ?
                    <Box component="span">{translateText(errorMessage)}</Box> : null}
                />
              }
              {isDatepicker &&
                // <DatePicker {...{ ...itemProps, onChange: value => onChange(key, moment(value).format('MM/DD/YYYY')) }}
                // />
                // <Box className="datePickerContainer"
                //   style = {{ height: '28px', marginTop: '-10px' }}>
                <MuiThemeProvider theme={formLabelsTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    {/* <Grid container> */}
                    <DatePickerComponent
                      className="datePickerEffective"
                      defaultValue={selectedDate}
                      handleDateChange={onDateChange}
                      error= {Boolean(!selectedDate && errorDate) || Boolean((JSON.stringify(selectedDate) === 'null') && errorDate) ? true : false

                      }
                      helperText={(!selectedDate && errorDate) ?
                        <Box style={{ 'marginLeft': '-1rem' }} component="span">
                          {translateText('Change of Address date is required.')}</Box> : ((JSON.stringify(selectedDate) === 'null') && errorDate)
                          ? <Box style={{ 'marginLeft': '-1rem' }} component="span">
                            {translateText('Invalid Date')}</Box> : ''}
                    />
                  </MuiPickersUtilsProvider>
                </MuiThemeProvider>
                // </Box>
              }
              {isDropdown && items.length > 0 && <Box>
                <TextField variant="outlined" select
                  className="FTE_select"
                  InputLabelProps={{ shrink: false, margin: 'dense' }}
                  value={value || ' '}
                  fullWidth
                  name={name}
                  error={error}
                  helperText={error ? <Box component="span">{translateText(errorMessage)}</Box> : null}
                  onChange={(e) => onChange(key, e.target.value, index)}>
                  {items.map((item, i) => {
                    return <MenuItem key={i} value={item.value || ' '}>
                      {translateText(item.label)}
                    </MenuItem>;
                  })}
                </TextField>

              </Box>}
              {isRadio && <InputRadio {...{ ...itemProps, onChange: value => onChange(key, value) }} />}
              {isPhone && <PhoneInput {...{ itemProps, onChange: value => onChange(key, value) }} />}
            </GridItem>
            {isPSDText &&
              <GridItem lg={3} key={i + 'psd'} className="pb-3 pr-3 mt-4">
                <a target="_blank" style={{ fontSize: '11px' }}
                  href="https://dced.pa.gov/local-government/local-income-tax-information/psd-codes-and-eit-rates/" rel="noreferrer">
                  {translateText('Click here to look up the PSD Code.')}
                </a>
              </GridItem>}

          </>
              }
            </>
          );
        })}
      </Grid>
    </MuiThemeProvider>
  );
};


const PhoneInput = (props) => {
  const { itemProps, onChange } = props,
        { translateText } = useTranslateText(),
        { value, stateName, key, error, errorMessage } = itemProps,
        id = `phone-${kebabCase(stateName)}`;

  const { Box } = commonNodeModules;

  const onChangeNumber = (newValue) => {
    const len = newValue.length - 1,
          oldValueLen = value.length - 1,
          valArray = newValue.split(''),
          numRegx = /^[0-9]$/,
          isDeleteKeyUp = oldValueLen > len,
          lastDigit = valArray[len],
          isValid = numRegx.test(lastDigit);

    if (len > 13) return;
    if (!isDeleteKeyUp) {
      if (!isValid) return;
      if (len === 0) valArray.splice(0, 0, '(');
      if (len === 3 || len === 4) {
        valArray.splice(4, 0, ')');
        valArray.splice(5, 0, ' ');
      }
      if (len === 5) valArray.splice(5, 0, ' ');
      if (len === 8 || len === 9) valArray.splice(9, 0, '-');
    }
    const val = valArray.join('');
    onChange(val);
  };

  return <TextFieldComponent
    id={id}
    value={value}
    name={key}
    required
    lable=""
    autoComplete="off"
    onChange={(e) => onChangeNumber(e.target.value)}
    error={error}
    helperText={error ?
      <Box component="span">{translateText(errorMessage)}</Box> : null}
  />;
};


export default InputFormEvents;